import Service from './service.js';
import Pagination from '@/components/pagination/index.vue';
import { errorMessage } from '@/utils/message.js';

export default {
  components: {
    Pagination
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    bankName: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      correspondNumberFlag: true,
      activeRowId: '', // 选择的联行号
      tableList: [],
      total: 0,
      pageNum: 1,
      pageSize: 10
    };
  },
  created() {
    console.log(this.bankName, '========ssssssss');
    this.getByBankNameList();
  },
  methods: {
    // 确定
    confirmInput(flag) {
      if(flag === true) {
        if(!this.activeRowId) {
          errorMessage('请选择开户银行联行号');
          return;
        }
        let result = this.tableList.find(item => item.id === this.activeRowId);
        if(result) {
          let bankInfo = {
            bankName: result.bankName,
            correspondNumber: result.correspondCode
          };
          this.$emit('changeInfo', bankInfo);
        }
      } else {
        this.$emit('changeInfo');
      }
      this.activeRowId = '';
      this.$emit('update:dialogVisible', false);
    },
    // 查询 根据输入开户银行进行模糊查询 至少四位
    getByBankNameList(page) {
      if(this.bankName && this.bankName.length >= 4) {
        if (page && page.pageNo && page.pageSize) {
          this.pageNum = page.pageNo;
          this.pageSize = page.pageSize;
        }
        let params = {
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          bankName: this.bankName
        };
        Service.getBankCorrespond(params).then(({ code, data }) => {
          if(code === '0') {
            this.tableList = data.list;
            this.total = data.total;
          }
        });
      }
    }
  }
};
